module.exports = __webpack_public_path__ + "img/vatican-city.afebadeb.png";